import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class HistoryService {

  private history: string[] = []

  constructor(
    private router: Router,
    private location: Location
  ) {
    // Listen to router events of type NavigationEnd to
    // manage an app-specific navigation history.
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.history[this.history.length - 1] != event.urlAfterRedirects) {
          this.history.push(event.urlAfterRedirects);
        }
      }
    })
  }

  get historyList() {
    return this.history;
  }

  deleteLastRoute() {
    this.history.pop();
  }

  clearToCart() {
    while (this.history[this.history.length -1 ] != "/order/cart" 
            && this.history[this.history.length -1 ]  != "/bottomtabs/cart" 
            && this.history[this.history.length -1 ]  != "/group/join" 
            && !this.history[this.history.length -1 ].includes("/group/create/")) {
      this.history.pop();
    }
  }

  /**
   * Manage back navigation.
   */
  back(): void {
    this.history.pop();

    // If the history still contains entries after popping
    // the current URL off of the stack, we can safely
    // navigate back. Otherwise we're falling back to the
    // application root.
    if (this.history.length > 0) {
      const backUrl = this.history[this.history.length -1];
      this.router.navigateByUrl(backUrl);
    } else {
      this.router.navigateByUrl('/');
    }
  }

}
